import React, {useEffect, useState} from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {observer} from "mobx-react";
import {
    UserItem, UserInfo, UserName, UserEmail, ContentInfo
} from "@dropDesk/presentation/components/messages/message_box/arrow_menu_popover/modals/message_data/styled";
import AvatarImage from "@dropDesk/presentation/components/avatar";

const MessageDataUserItem = observer((
    {
        user,
    }: {
        user: UserEntity
    }
) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;


    return (
        <UserItem key={user.id}>
            <ContentInfo>
                <AvatarImage
                    useCursorPointer={!!user.urlImageProfile}
                    title={user.name}
                    size={35}
                    url={user.urlImageProfile}
                    round={true}
                    hasPreviewImage={true}
                    withBorder={true}
                    onClick={(event) => event.stopPropagation()}
                />
                <UserInfo borderColor={colors.border }>
                    <UserName color={colors.text}>{user.name}</UserName>
                    <UserEmail color={colors.hint}>{user.email ?? user.telephone ?? ''}</UserEmail>
                </UserInfo>
            </ContentInfo>
        </UserItem>
    )
});
export default MessageDataUserItem;
